export const GOOGLE_PAYMENT_METHOD_NAME = "GooglePay";

export const GOOGLE_PAYMENT_METHOD_WALLET_SOURCE = "GOOGLEPAY";
